import React, { useState} from 'react'
import { Table,Container,Row,Card,CardHeader,CardBody,CardFooter, Button, Col } from "reactstrap";
import Header from 'components/Headers/Header';
import {eventByDate,reportByEvent} from 'network/ApiAxiosTickets'
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css";
import SellerDropdown from './SellerDropdown';
import EventDropdown from './EventDropdown';


const ReportComissionByEvent = () => {
    const [startDate, setStartDate] = useState(null);
    const [data, setData] = useState({});
    const [sellerID, setSellerID] = useState("");
    const [eventID, setEventID] = useState("");

    const onChange = (date) => {
        const start = date;
        setStartDate(addHours(2,start));
    };

    function addHours(numOfHours, date = new Date()) {
    date.setHours(date.getHours() + numOfHours);
    return date;
    }

    const getReport = async(e)=>{
        e.preventDefault()
        if(eventID){
            const res = await reportByEvent(eventID,sellerID,startDate)
            if(res.data.success) {
                setData(res.data.totals)
            }
        }
    }

    const handleSellerFilter = (e)=>{
        setSellerID(e)
    }

    const handleEventFilter = (e)=>{
        console.log(e)
        setEventID(e)
    }

    const role = JSON.parse(localStorage.getItem('user')).role

    return (
    <>
        {role == 'admin' && <Header/>}
        <Container fluid>
            <Row>
                <div className="col mt-6">
                    <Card className="shadow">
                        <CardHeader className="border-0">
                            <h2 className=' float-right'>Reports</h2>
                            <Row>
                                <Col>
                                    <label>Date:</label>
                                    <DatePicker
                                    //selected={startDate}
                                    selected={startDate}
                                    onChange={onChange}
                                    startDate={startDate}
                                    dateFormat="dd/MM/yyyy"
                                    calendarStartDay={1}
                                    /> 
                                </Col>
                                <Col>
                                    <label>Event:</label>
                                    <EventDropdown width="200px" date={startDate} handler={(e)=>handleEventFilter(e)} />
                                </Col>
                                <Col>
                                    <label>Seller:</label>
                                    <SellerDropdown width="200px" handler={(e)=>handleSellerFilter(e)} />
                                </Col>
                            </Row>   
                            <Button onClick={getReport}> GO </Button>
                        </CardHeader>
                        {data.sellerName &&
                        <CardBody>
                            
                            <h3>Totals</h3>
                            <Table className="align-items-center table-flush" hover responsive striped>
                                <tbody>
                                    <tr>
                                        <th scope="col">Total Money</th><th scope="col">{data.Money}</th>
                                    </tr>
                                    <tr>
                                        <th scope="col">Tickets Sold</th><th scope="col">{data.Tickets}</th>
                                    </tr>
                                    <tr>
                                        <th scope="col">Total Seller Comission</th><th scope="col">{data.SellerComission}</th>
                                    </tr>
                                    <tr>
                                        <th scope="col">Total House</th><th scope="col">{data.Money - data.SellerComission - Object.entries(data.vip).reduce((acc, curr) => acc + (typeof curr[1] === 'number' ? curr[1] : 0), 0)}</th>
                                    </tr>
                                </tbody>
                            </Table>

                            {data.sellerName &&
                            <>
                            <h3 className='mt-4' >Seller Comissions</h3>
                            <Table className="align-items-center table-flush" hover responsive striped>
                                <thead className="thead-light">
                                    <tr>
                                        <th scope="col">Seller</th>
                                        <th scope="col" className='text-center'>Tickets Sold</th>
                                        <th scope="col" className='text-center'>Comission</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Object.entries(data.sellerName).map((row)=>{
                                        console.log(row)
                                        return <tr key={row[0]}>
                                                    <th scope="col">{row[0]}</th>
                                                    <th scope="col" className='text-center'>
                                                        {row[1].Tickets}
                                                    </th>
                                                    <th scope="col" className='text-center'>
                                                        {row[1].Comission}
                                                    </th>
                                               </tr>
                                    })}
                                </tbody>
                            </Table>
                            </>}

                            {data.vip != {} &&
                            <>
                            <h3 className='mt-4' >Seller VIP Comissions</h3>
                            <Table className="align-items-center table-flush" hover responsive striped>
                                <thead className="thead-light">
                                    <tr>
                                        <th scope="col">Seller</th>
                                        <th scope="col" className='text-center'>Comission</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Object.entries(data.vip).map((row,rowIndex)=>{
                                        //console.log(row)
                                        return <tr key={row[0] + ' ' + rowIndex}>
                                                    <th scope="col">{row[0]}</th>
                                                    <th scope="col" className='text-center'>
                                                        {row[1]}
                                                    </th>
                                               </tr>
                                    })}
                                </tbody>
                            </Table>
                            </>}

                            {data.missing != {} &&
                            <>
                            <h3 className='mt-4' >Money not given to shop</h3>
                            <Table className="align-items-center table-flush" hover responsive striped>
                                <thead className="thead-light">
                                    <tr>
                                        <th scope="col">Seller</th>
                                        <th scope="col">Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Object.entries(data.missing).map((row)=>{
                                        return <tr key={row[0]}><th scope="col">{row[0]}</th><th scope="col">{row[1]}</th></tr>
                                    })}
                                    
                                </tbody>
                            </Table>
                            </>}
                            {data.Deposits != {} &&
                                <>
                                    <h3 className='mt-4' >Deposits not Collected</h3>
                                    <Table className="align-items-center table-flush" hover responsive striped>
                                        <thead className="thead-light">
                                            <tr>
                                                <th scope="col">Event</th>
                                                <th scope="col">Amount</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {Object.entries(data.Deposits).map((row)=>{
                                                return <tr><th scope="col">{row[0]}</th><th scope="col">{row[1]}</th></tr>
                                            })}
                                            
                                        </tbody>
                                    </Table>
                                </>
                            }



                        </CardBody>
                        }
                        <CardFooter className="py-4">
                            
                        </CardFooter>
                    </Card>
                </div>
            </Row>
        </Container>
    </>
    )
}

export default ReportComissionByEvent
